import TurndownService from 'turndown';
import { gfm } from 'turndown-plugin-gfm';
import marked from 'marked';

const turndownService = new TurndownService({
  headingStyle: 'atx',
  hr: '---',
  bulletListMarker: '-',
  codeBlockStyle: 'fenced'
});
turndownService.use(gfm);
turndownService.keep([
  'script',
  'iframe'
]);

const KeepPattern = new RegExp(/(\[##_.*?_##\])/g);
class MarkdownKeeper {
  constructor() {
    this.keepItems = [];
  }

  keep(content) {
    this.keepItems = content.match(KeepPattern);
    if (this.keepItems) {
      this.keepItems.map((item, index) => {
        content =content.replace(item, `(::${index}::)`);
      });
    }
    return content;
  }

  restore(content) {
    if (this.keepItems) {
      this.keepItems.map((item, index) => {
        content = content.replace(`(::${index}::)`, item);
      });
    }
    return content;
  }
}

class MarkdownHelper {
  static htmlToMarkdown(content) {
    if (!content) {
      return '';
    }

    const keeper = new MarkdownKeeper();
    let result = keeper.keep(content);
    result = turndownService.turndown(result);
    return keeper.restore(result);
  }

  static markdownToHtml(content) {
    if (!content) {
      return '';
    }

    const keeper = new MarkdownKeeper();
    let result = keeper.keep(content);
    result = marked(result, {
      gfm: true,
      breaks: true,
      headerIds: false
    });
    return keeper.restore(result);
  }
}

export default MarkdownHelper
